import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-26/task-02";

const task: Slide = {
  titleHtml:
    "Which methods are mainly employed to evaluate audio processing systems for which<br>an ideal reference is unavailable or impractical to define?",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
